/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import {
  env,
  installEnvDep,
  curEnv,
} from '../utils/env';


if (curEnv === env.WX_MP && typeof wx === 'undefined') {
  installEnvDep('https://res.wx.qq.com/open/js/jweixin-1.3.2.js');
}

const Router = {
  pathDict: {
    shop: {
      [curEnv]: '/pages/sub-packages/shop/pages/index/index',
    },
    'product-detail': {
      [curEnv]: '/pages/product/detail/index',
    },
    coupon: {
      [curEnv]: '/pages/newuser/coupon/index',
    },
    home: {
      [curEnv]: '/pages/index/index',
    },
    'web-page': {
      [curEnv]: '/pages/web-page/index',
    },
    'ares-page': {
      [curEnv]: '/pages/ares/ares-page/index',
    },
    'ares-web-page': {
      [curEnv]: '/pages/ares/ares-web-page/index',
    },
  },
};

Router.jumpPage = function (url) {
  if (window.__wxjs_environment === 'miniprogram') {
    try {
      wx.miniProgram.navigateTo({
        url,
        fail() {
          wx.miniProgram.switchTab({
            url,
          });
        },
        success() {
          wx.miniProgram.switchTab({
            url,
          });
        },
      });
    } catch (err) {

    }
  } else {
    window.location.href = url;
  }
};

Router.convert = function (route) {
  let url = '';
  if (route) {
    const arr = route.split('?');
    const name = arr[0];
    const mapUrl = this.pathDict[name] && this.pathDict[name][curEnv];
    if (mapUrl) {
      if (arr.length === 2) {
        url = `${mapUrl}?${arr[1]}`;
      } else {
        url = mapUrl;
      }
    } else {
      url = route;
    }
  }
  return url;
};

Router.go = function (url) {
  if (process.env.isEdit) return;
  if (url) {
    this.jumpPage(this.convert(url));
  }
};

export default Router;
